import { stateLogger as log } from 'common/services/logging/loggers';

const appStateDebugger = ['$rootScope', ($rootScope) => {

    const appStateDebuggerIsEnabled = localStorage.getItem('debug_state');

    if (!appStateDebuggerIsEnabled) {

        return;

    }

    const stateChange = {
        flow: [],
    };

    $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState = 'empty state', fromParams) => {

        log.info({
            type: `State Transition event $stateChangeStart to ${toState.name} - fired when the transition begins.`,
            cmd: '',
            data: {
                fromState,
                fromParams,
                toState,
                toParams,
            },

        });

    });
    $rootScope.$on('$stateChangeError', () => {

        const argumentsArray = Array.prototype.slice.call(arguments);

        log.info({
            type: 'State Transition Error',
            cmd: '',
            data: '$stateChangeError -  fired when an error in state transition happens.',
            params: argumentsArray,
        });

    });

    $rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {

        log.info({
            type: `State Transition event $stateChangeSuccess to ${toState.name} - fired when the transition begins.`,
            cmd: '',
            data: {
                fromState,
                fromParams,
                toState,
                toParams,
            },
        });
        stateChange.flow.push(`${fromState.name} --> ${toState.name}`);
        log.info({
            type: 'State transition flow up to this point, including latest stateChange',
            cmd: '',
            data: {
                stateChange,
            },

        });
        stateChange.flow.push(`${fromState.name} --> ${toState.name}`);
        log.info({
            type: 'State transition flow up to this point, including latest stateChange',
            cmd: '',
            data: {
                stateChange,
            },

        });

    });

    $rootScope.$on('$stateNotFound', (event, unfoundState, fromState, fromParams) => {

        log.info({
            type: `State Transition event $stateNotFound to ${unfoundState.to} - fired when a state cannot be found by its name.`,
            cmd: '',
            data: {
                event,
                fromState,
                fromParams,
                unfoundState,
            },
        });

    });

}];

export default appStateDebugger;



// WEBPACK FOOTER //
// ./scripts/app/appStateDebugger.js